"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../styles/WhatYourNeedComponent.css");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
const AboutThisSystemModalComponent = _ref => {
  let {
    heading,
    content
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ats-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ats-heading"
  }, heading), /*#__PURE__*/_react.default.createElement("div", {
    className: "ats-subheading"
  }, "About this system"), /*#__PURE__*/_react.default.createElement("div", {
    className: "ats-content"
  }, content), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: "13px",
      fontWeight: "700",
      color: "#333333"
    }
  }, "Learn more about ", /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.smallPentairLogo.default,
    alt: "",
    style: {
      height: "14px",
      width: "10px"
    }
  }), " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.pentair.com/en-us/commercial-filtration/brands/everpure.html",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: "#006E96"
    }
  }, "Everpure"), " here."));
};
var _default = exports.default = AboutThisSystemModalComponent;